module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Daze Days 2022","short_name":"Daze Days","start_url":"/","background_color":"#fff8e4","theme_color":"#fff8e4","display":"standalone","icon":"src/images/icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"3165b2a493ec8ba00e9b2f3f3ed24844"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
